<template>
  <svg :class="iconClass" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M3 6H21" stroke="#333333" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M3 12H21" stroke="#333333" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M3 18H21" stroke="#333333" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script setup>
defineProps({
  iconClass: {
    type: String,
    default: '',
  }
});
</script>